import { writable } from 'svelte/store';
import { HelpInformationService } from '@/services';
const initialState = {
    items: [],
    activeItem: '',
    activeId: null
};
// Init state
const { subscribe, update } = writable(initialState);
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    async getHelpInformation() {
        await new HelpInformationService().getHelpInformation().then(response => {
            if (response) {
                update(fs => {
                    return {
                        ...fs,
                        items: response
                    };
                });
            }
        });
    }
};
const helpStore = {
    ...actions,
    subscribe
};
export default helpStore;
